const EnterprisePlane: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="67.878" height="137.873" viewBox="0 0 67.878 137.873">
      <g id="Group_35730" data-name="Group 35730" transform="translate(-1278.549 -1481.952)">
        <ellipse
          id="Ellipse_55"
          data-name="Ellipse 55"
          cx="19.333"
          cy="3.461"
          rx="19.333"
          ry="3.461"
          transform="translate(1293.272 1612.903)"
          fill="#cad7ef"
        />
        <path
          id="Path_3294"
          data-name="Path 3294"
          d="M124.171,50.323s13,2.7,17.895,14.911c0,0,1.994-28.463-16.054-28.463Z"
          transform="translate(1203.629 1491.641)"
          fill="#fff"
        />
        <path
          id="Path_3295"
          data-name="Path 3295"
          d="M126.339,42.632l-.411-5.082-1.757,8.121c11.042,1.373,17.895,14.911,17.895,14.911C141.041,48.941,126.339,42.632,126.339,42.632Z"
          transform="translate(1203.629 1496.288)"
          fill="#cad7ef"
        />
        <g id="Group_1215" data-name="Group 1215" transform="translate(1327.654 1527.714)">
          <path
            id="Path_3296"
            data-name="Path 3296"
            d="M142.728,69.044l-1.185-2.956c-4.7-11.725-17.267-14.458-17.393-14.486l.286-1.359c.5.1,11.433,2.482,17.058,12.513-.153-5.1-1.143-15.4-6.406-20.934a11.877,11.877,0,0,0-8.951-3.757V36.671a13.251,13.251,0,0,1,9.962,4.19c7.564,7.954,6.825,24.315,6.79,25.005Z"
            transform="translate(-124.15 -36.671)"
            fill="#545f7f"
          />
        </g>
        <path
          id="Path_3297"
          data-name="Path 3297"
          d="M135.121,50.323s-13.008,2.7-17.9,14.911c0,0-1.094-28.463,16.054-28.463Z"
          transform="translate(1162.036 1491.641)"
          fill="#fff"
        />
        <path
          id="Path_3298"
          data-name="Path 3298"
          d="M132.941,42.632l.411-5.082,1.757,8.121c-11.049,1.373-17.9,14.911-17.9,14.911C118.232,48.941,132.941,42.632,132.941,42.632Z"
          transform="translate(1162.047 1496.288)"
          fill="#cad7ef"
        />
        <g id="Group_1216" data-name="Group 1216" transform="translate(1278.549 1527.714)">
          <path
            id="Path_3299"
            data-name="Path 3299"
            d="M117.233,69.156l-.112-3.3c-.028-.7-.523-17.239,7.1-25.131a12.928,12.928,0,0,1,9.648-4.057v1.394a11.584,11.584,0,0,0-8.644,3.625c-5.284,5.472-6.427,15.8-6.664,20.983,5.64-9.962,16.514-12.332,17.009-12.429l.286,1.359c-.125.028-12.7,2.781-17.393,14.486Z"
            transform="translate(-117.106 -36.671)"
            fill="#545f7f"
          />
        </g>
        <path
          id="Path_3300"
          data-name="Path 3300"
          d="M136.572,30.254s-17.023,19.951-17.023,44.552A63.977,63.977,0,0,0,124.5,98.647s12.7,3.437,24.148,0A63.976,63.976,0,0,0,153.6,74.806C153.6,50.205,136.572,30.254,136.572,30.254Z"
          transform="translate(1176.031 1452.771)"
          fill="#fff"
        />
        <path
          id="Path_3301"
          data-name="Path 3301"
          d="M125.5,89.354c12.6-28.951-3.046-56.277-3.046-56.277l4.824-1.067s16.947,26.8,3.994,56.152Z"
          transform="translate(1193.402 1463.244)"
          fill="#cad7ef"
        />
        <path
          id="Path_3302"
          data-name="Path 3302"
          d="M121.933,30.377s3.82,6.581,4.559,12.966l3.925-1.227s-6.915-12.778-8.484-11.739Z"
          transform="translate(1190.266 1453.165)"
          fill="#cad7ef"
        />
        <g id="Group_1217" data-name="Group 1217" transform="translate(1294.883 1481.952)">
          <path
            id="Path_3303"
            data-name="Path 3303"
            d="M137.853,101.8a54.452,54.452,0,0,1-12.938-1.562,60.419,60.419,0,0,1-5.465-24.517c0-24.573,17.023-44.8,17.191-45l.53-.627.537.627c.167.2,17.184,20.425,17.184,45A64.606,64.606,0,0,1,149.9,99.831l-.174.432h-.377A40.575,40.575,0,0,1,137.853,101.8Zm-12.241-2.823c2.043.488,13.1,2.9,23.116.014A62.957,62.957,0,0,0,153.5,75.725c0-21.617-13.461-39.812-16.326-43.444-2.858,3.632-16.326,21.84-16.326,43.444A62.831,62.831,0,0,0,125.611,98.981Z"
            transform="translate(-119.449 -30.1)"
            fill="#545f7f"
          />
        </g>
        <path
          id="Path_3304"
          data-name="Path 3304"
          d="M146.466,52.433A27.863,27.863,0,0,1,135.02,75.347a28.09,28.09,0,0,1-11.474-22.112c0-.516.028-.8.028-.8-1.966.927-3.764,4.949-3.764,4.949.453-10.359,2.928-14.576,2.928-14.576H147.3s2.482,4.217,2.928,14.576C150.231,57.382,148.432,53.36,146.466,52.433Z"
          transform="translate(1177.584 1527.622)"
          fill="#fff"
        />
        <path
          id="Path_3305"
          data-name="Path 3305"
          d="M133.437,52.433a27.863,27.863,0,0,1-11.446,22.914c9.244-11.725,6.783-29.648,6.783-29.648A9.59,9.59,0,0,1,132.1,48.32c-.063-4.085-2.5-4.929-2.5-4.929l4.51-.586c.167,0,2.649,4.217,3.1,14.576C137.2,57.382,135.4,53.36,133.437,52.433Z"
          transform="translate(1190.613 1527.622)"
          fill="#cad7ef"
        />
        <g id="Group_1218" data-name="Group 1218" transform="translate(1296.542 1569.731)">
          <path
            id="Path_3306"
            data-name="Path 3306"
            d="M135.748,76.822l-.418-.321a28.838,28.838,0,0,1-11.739-22.049,15.742,15.742,0,0,0-2.412,3.813L119.687,61.6l.16-3.653c.446-10.415,2.914-14.723,3.018-14.9l.2-.349h25.368l.2.349c.1.174,2.565,4.482,3.018,14.9l.153,3.653-1.492-3.339a15.5,15.5,0,0,0-2.419-3.827A29.083,29.083,0,0,1,136.167,76.5ZM125.1,51.887l-.1,1.2c0,.021-.021.286-.021.746a27.328,27.328,0,0,0,10.777,21.234A27.393,27.393,0,0,0,146.5,53.086l-.091-1.192,1.081.509a7.2,7.2,0,0,1,2.558,2.53c-.586-6.4-1.959-9.8-2.447-10.833H123.891c-.481,1.032-1.861,4.427-2.447,10.833A7.259,7.259,0,0,1,124,52.4Z"
            transform="translate(-119.687 -42.706)"
            fill="#545f7f"
          />
        </g>
        <ellipse
          id="Ellipse_56"
          data-name="Ellipse 56"
          cx="8.077"
          cy="8.077"
          rx="8.077"
          ry="8.077"
          transform="translate(1304.528 1519.476)"
          fill="#cad7ef"
        />
        <g id="Group_1219" data-name="Group 1219" transform="translate(1303.827 1518.779)">
          <path
            id="Path_3307"
            data-name="Path 3307"
            d="M129.509,52.933a8.773,8.773,0,1,1,8.777-8.77A8.782,8.782,0,0,1,129.509,52.933Zm0-16.152a7.379,7.379,0,1,0,7.382,7.382A7.39,7.39,0,0,0,129.509,36.781Z"
            transform="translate(-120.732 -35.387)"
            fill="#545f7f"
          />
        </g>
        <path
          id="Path_3308"
          data-name="Path 3308"
          d="M130.468,38.272a4.566,4.566,0,1,0-4.566,4.566A4.564,4.564,0,0,0,130.468,38.272Z"
          transform="translate(1186.702 1473.372)"
          fill="#cad7ef"
        />
        <g id="Group_1220" data-name="Group 1220" transform="translate(1307.34 1506.381)">
          <path
            id="Path_3309"
            data-name="Path 3309"
            d="M126.5,44.132a5.263,5.263,0,1,1,5.263-5.263A5.267,5.267,0,0,1,126.5,44.132Zm0-9.132a3.869,3.869,0,1,0,3.869,3.869A3.874,3.874,0,0,0,126.5,35Z"
            transform="translate(-121.236 -33.606)"
            fill="#545f7f"
          />
        </g>
        <path
          id="Path_3310"
          data-name="Path 3310"
          d="M150.892,40.065s7.557,8.093,7.557,18.013c0,0-6.56,2.029-19.637,2.029s-19.637-2.029-19.637-2.029c0-9.92,7.564-18.013,7.564-18.013s12.7,2.5,24.148,0Z"
          transform="translate(1173.792 1511.285)"
          fill="#fff"
        />
        <path
          id="Path_3311"
          data-name="Path 3311"
          d="M140.1,40.065l-3.653.871s6.5,9.948,6.107,14.681c0,0-7.752,3.492-21.568,4.273,0,0,17.567.8,26.671-1.812C147.653,58.078,145.576,45.21,140.1,40.065Z"
          transform="translate(1184.588 1511.285)"
          fill="#cad7ef"
        />
        <g id="Group_1221" data-name="Group 1221" transform="translate(1292.27 1550.59)">
          <path
            id="Path_3312"
            data-name="Path 3312"
            d="M139.408,61.455c-13.029,0-19.575-1.973-19.847-2.063l-.488-.146v-.516c0-10.08,7.431-18.146,7.752-18.487l.265-.286.376.077c.125.028,12.7,2.44,23.869,0,.983.551,8.407,8.616,8.407,18.7v.516l-.488.146C158.983,59.482,152.437,61.455,139.408,61.455ZM120.475,58.2c1.757.446,8.128,1.861,18.933,1.861s17.177-1.415,18.933-1.861c-.23-8.275-5.828-15.239-7.1-16.717-10.22,2.119-21.415.376-23.639-.007C126.338,42.933,120.705,49.918,120.475,58.2Z"
            transform="translate(-119.074 -39.956)"
            fill="#545f7f"
          />
        </g>
        <g id="Group_1222" data-name="Group 1222" transform="translate(1304.294 1494.609)">
          <path
            id="Path_3313"
            data-name="Path 3313"
            d="M129.38,34.508a28.515,28.515,0,0,1-8.581-1.269l.46-1.318a27.982,27.982,0,0,0,15.992-.007l.425,1.324A26.9,26.9,0,0,1,129.38,34.508Z"
            transform="translate(-120.799 -31.915)"
            fill="#545f7f"
          />
        </g>
      </g>
    </svg>
  );
};

export default EnterprisePlane;
